import React from 'react';

/**
 * Engineering grid SVG overlay.
 * 1px lines at #2A2E36 with 10% opacity. Tileable via SVG <pattern>.
 *
 * Usage:
 *   <div className="relative">
 *     <GridOverlay />
 *     ...content...
 *   </div>
 */
export const GridOverlay = ({ size = 48, className = '', opacity = 0.1 }) => {
    const id = `grid-${size}`;
    return (
        <svg
            aria-hidden="true"
            className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            data-testid="grid-overlay"
        >
            <defs>
                <pattern
                    id={id}
                    width={size}
                    height={size}
                    patternUnits="userSpaceOnUse"
                >
                    <path
                        d={`M ${size} 0 L 0 0 0 ${size}`}
                        fill="none"
                        stroke="#2789C5"
                        strokeWidth="1"
                        opacity={opacity}
                    />
                </pattern>
            </defs>
            <rect width="100%" height="100%" fill={`url(#${id})`} />
        </svg>
    );
};

export default GridOverlay;
